module.exports = "././img/QLD_CoA_Website_LOGO-black.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/QLD_CoA_Website_LOGO-black.svg
// module id = 814
// module chunks = 0